import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'tc-right-sidebar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './right-sidebar.component.html',
  styleUrl: './right-sidebar.component.css',
})
export class RightSidebarComponent {
  @Input() visible = false;
  @Input() width = '25rem';
  @Input() showBackdrop = true;
  @Input() showCloseButton = true;
  @Input() bodyScrollable = true;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() sidebarToggled = new EventEmitter<void>();

  toggleSidebar(): void {
    this.visible = !this.visible;
    this.visibleChange.emit(this.visible);
    this.sidebarToggled.emit();
  }

  closeSidebar(): void {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }
}
